/* eslint-disable */
/* @ts-ignore */
/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */
 
declare const module: {
  hot?: {
    accept: () => void;
    status: () => string;
  };
};

// @ts-ignore
const isHotReloadEnabled = typeof module !== 'undefined' && module.hot;

if (isHotReloadEnabled) {
  // @ts-ignore
  module.hot.accept();
}
import * as Types from '@/backoffice/types/types.generated';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { baseBillingBackofficeApi } from '../../base-api';
export type SewSalesExportQueryVariables = Types.Exact<{
  startBillingCycleReferenceTs?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  endBillingCycleReferenceTs?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type SewSalesExportQuery = { __typename: 'Query', sewSalesExport: { __typename: 'BillingSewSalesExport', url: string, log?: string, hasErrors?: boolean } };

export type SewCreditConsumptionExportQueryVariables = Types.Exact<{
  startBillingCycleReferenceTs?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  endBillingCycleReferenceTs?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type SewCreditConsumptionExportQuery = { __typename: 'Query', sewSdaCreditConsumptionExport: { __typename: 'BillingSewSdaCreditConsumptionExport', url: string, log?: string, hasErrors?: boolean } };

export type SewSapExportQueryVariables = Types.Exact<{
  billingCycleReferenceTs?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  region: Types.BillingSewRegionEnum;
}>;


export type SewSapExportQuery = { __typename: 'Query', sewSapExport: { __typename: 'BillingSewSapExport', url: string, log?: string, hasErrors?: boolean } };

export type SewInternalSapExportQueryVariables = Types.Exact<{
  billingCycleReferenceTs?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type SewInternalSapExportQuery = { __typename: 'Query', sewInternalSapExport: { __typename: 'BillingSewSapExport', url: string, log?: string, hasErrors?: boolean } };

export type SewInternalCostCenterExportQueryVariables = Types.Exact<{
  startBillingCycleReferenceTs?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  endBillingCycleReferenceTs?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type SewInternalCostCenterExportQuery = { __typename: 'Query', sewInternalCostCenterExport: { __typename: 'BillingSewInternalCostCenterExport', url: string, log?: string, hasErrors?: boolean } };

export type ResalePlansExportQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ResalePlansExportQuery = { __typename: 'Query', resalePlansExport: { __typename: 'BillingExport', url: string } };

export type ReadTenantsLatestSubscriptionsQueryVariables = Types.Exact<{
  tenantIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type ReadTenantsLatestSubscriptionsQuery = { __typename: 'Query', tenantsLatestSubscriptions: Array<{ __typename: 'BillingTenantLatestSubscription', tenantId: string, subscription: { __typename: 'BillingSubscriptionSummary', tier: string, term: { __typename: 'BillingTerm', startTs?: number, expirationTs?: number, cancellationTs?: number } } }> };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const SewSalesExportDocument = new TypedDocumentString(`
    query SewSalesExport($startBillingCycleReferenceTs: Int, $endBillingCycleReferenceTs: Int) {
  __typename
  sewSalesExport(
    params: {startBillingCycleReferenceTs: $startBillingCycleReferenceTs, endBillingCycleReferenceTs: $endBillingCycleReferenceTs}
  ) {
    __typename
    url
    log
    hasErrors
  }
}
    `);
export const SewCreditConsumptionExportDocument = new TypedDocumentString(`
    query SewCreditConsumptionExport($startBillingCycleReferenceTs: Int, $endBillingCycleReferenceTs: Int) {
  __typename
  sewSdaCreditConsumptionExport(
    params: {startBillingCycleReferenceTs: $startBillingCycleReferenceTs, endBillingCycleReferenceTs: $endBillingCycleReferenceTs}
  ) {
    __typename
    url
    log
    hasErrors
  }
}
    `);
export const SewSapExportDocument = new TypedDocumentString(`
    query SewSapExport($billingCycleReferenceTs: Int, $region: BillingSewRegionEnum!) {
  __typename
  sewSapExport(
    params: {billingCycleReferenceTs: $billingCycleReferenceTs, region: $region}
  ) {
    __typename
    url
    log
    hasErrors
  }
}
    `);
export const SewInternalSapExportDocument = new TypedDocumentString(`
    query SewInternalSapExport($billingCycleReferenceTs: Int) {
  __typename
  sewInternalSapExport(
    params: {billingCycleReferenceTs: $billingCycleReferenceTs}
  ) {
    __typename
    url
    log
    hasErrors
  }
}
    `);
export const SewInternalCostCenterExportDocument = new TypedDocumentString(`
    query SewInternalCostCenterExport($startBillingCycleReferenceTs: Int, $endBillingCycleReferenceTs: Int) {
  __typename
  sewInternalCostCenterExport(
    params: {startBillingCycleReferenceTs: $startBillingCycleReferenceTs, endBillingCycleReferenceTs: $endBillingCycleReferenceTs}
  ) {
    __typename
    url
    log
    hasErrors
  }
}
    `);
export const ResalePlansExportDocument = new TypedDocumentString(`
    query ResalePlansExport {
  __typename
  resalePlansExport {
    __typename
    url
  }
}
    `);
export const ReadTenantsLatestSubscriptionsDocument = new TypedDocumentString(`
    query ReadTenantsLatestSubscriptions($tenantIds: [String!]!) {
  __typename
  tenantsLatestSubscriptions(tenantIds: $tenantIds) {
    __typename
    tenantId
    subscription {
      __typename
      tier
      term {
        __typename
        startTs
        expirationTs
        cancellationTs
      }
    }
  }
}
    `);

const injectedRtkApi = baseBillingBackofficeApi.injectEndpoints({
  overrideExisting: isHotReloadEnabled && module.hot?.status() === "apply",
  endpoints: (build) => ({
    SewSalesExport: build.query<Types.SewSalesExportQuery, Types.SewSalesExportQueryVariables | void>({
      query: (variables) => ({ document: SewSalesExportDocument as unknown as string, variables })
    }),
    SewCreditConsumptionExport: build.query<Types.SewCreditConsumptionExportQuery, Types.SewCreditConsumptionExportQueryVariables | void>({
      query: (variables) => ({ document: SewCreditConsumptionExportDocument as unknown as string, variables })
    }),
    SewSapExport: build.query<Types.SewSapExportQuery, Types.SewSapExportQueryVariables>({
      query: (variables) => ({ document: SewSapExportDocument as unknown as string, variables })
    }),
    SewInternalSapExport: build.query<Types.SewInternalSapExportQuery, Types.SewInternalSapExportQueryVariables | void>({
      query: (variables) => ({ document: SewInternalSapExportDocument as unknown as string, variables })
    }),
    SewInternalCostCenterExport: build.query<Types.SewInternalCostCenterExportQuery, Types.SewInternalCostCenterExportQueryVariables | void>({
      query: (variables) => ({ document: SewInternalCostCenterExportDocument as unknown as string, variables })
    }),
    ResalePlansExport: build.query<Types.ResalePlansExportQuery, Types.ResalePlansExportQueryVariables | void>({
      query: (variables) => ({ document: ResalePlansExportDocument as unknown as string, variables })
    }),
    ReadTenantsLatestSubscriptions: build.query<Types.ReadTenantsLatestSubscriptionsQuery, Types.ReadTenantsLatestSubscriptionsQueryVariables>({
      query: (variables) => ({ document: ReadTenantsLatestSubscriptionsDocument as unknown as string, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useSewSalesExportQuery, useLazySewSalesExportQuery, useSewCreditConsumptionExportQuery, useLazySewCreditConsumptionExportQuery, useSewSapExportQuery, useLazySewSapExportQuery, useSewInternalSapExportQuery, useLazySewInternalSapExportQuery, useSewInternalCostCenterExportQuery, useLazySewInternalCostCenterExportQuery, useResalePlansExportQuery, useLazyResalePlansExportQuery, useReadTenantsLatestSubscriptionsQuery, useLazyReadTenantsLatestSubscriptionsQuery } = injectedRtkApi;

